import { apiClient } from '../../gateways/api'
import type { FetchHoofdleidingContextLists } from '../types/FetchHoofdleidingContextLists'

export { fetchHoofdleidingContextLists, initialState }

const initialState: FetchHoofdleidingContextLists = {
  data: {
    aannemers: [],
    netbeheerderDisciplines: [],
    labels: [],
  },
}

const fetchHoofdleidingContextLists = async ({
  gebiedscode,
  verantwoordelijke,
}: {
  gebiedscode: string
  verantwoordelijke?: string
}): Promise<FetchHoofdleidingContextLists['data']> => {
  const { data } = await apiClient({
    url: '/rest/hoofdleiding/lists/context',
    method: 'GET',
    params: { gebiedscode, verantwoordelijke },
  })
  return data
}
